export default "__VITE_ASSET__9ac79210__"